import angular from 'angular';
import ConfigsModule from '../../configs/configs';
import ResourcesModule from '../../resources/resources';
import ServicesModule from '../../services/services';
import Map from '../map/map';
import template from './exploreMap.jade';

export class MarketplaceMapController {
  /* @ngInject */
  constructor($stateParams, currentGame, Resource, featureFlagsHelper, UserExplorerResource) {
    this.UserExplorerResource = UserExplorerResource;
    this.featureFlagsHelper = featureFlagsHelper;
    this.$stateParams = $stateParams;
    this.map = new Map({});

    this.Resource = Resource;
    this.disposables = [];

    this.disposables.push(currentGame.subscribe(game => {
      this.game = game;
    }));

    this.disposables.push(this.query
      .distinctUntilChanged(JSON.stringify)
      .subscribe((params) => {
        this.loadMapData(params);
      }));

    this.disposeObservable = (d) => { d.dispose() };

    this.$onDestroy = () => {
      _.forEach(this.disposables, (d) => { this.disposeObservable(d) });
    };

  }

  loadMapData(params) {
    this.UserExplorerResource.one(this.$stateParams.gameId).customPOST(params, 'breakdown', {breakdown_dimension: 'COUNTRY'}).then((res) => {
      this.callbacks.dataRetrievedCallback(res);

      let userGroupSeries = { rows:[] };
      let countryCodesArray = [];

      _.forOwn(res.breakdown, (breakdownObject, key) => {
        countryCodesArray.push(breakdownObject.dimension_value);
        userGroupSeries.rows.push({
          country: breakdownObject.dimension_value,
          players: breakdownObject.usergroup_value
        });
      });

      this.map.updateCountriesData(userGroupSeries.rows);
      this.map.updateSerie(countryCodesArray);
    });
  }

}

let MarketplaceMapComponentOptions = {
  template: () => { return template; },
  controller: MarketplaceMapController,
  controllerAs: 'vm',
  bindings: {
    query: '=',
    callbacks: '='
  }
};

export default angular.module('app.components.explore.playerExploreMap', [
  ConfigsModule.name,
  ResourcesModule.name,
  ServicesModule.name
])
  .component('playerExploreMap', MarketplaceMapComponentOptions);



/** WEBPACK FOOTER **
 ** ./src/components/explore/exploreMap.js
 **/